export const Rights = [
    "WEB_MODULE_APPOINTMENTS_APPROVE_WRITE"
]
